export default "__VITE_ASSET__BYtM8L6R__"